import {
  CategoryMapConfigFragment,
  EducationLevelFragment,
  ProfessionalCategoryFragment,
  TrainingsCategoryMapConfigCategoryEnum,
} from 'generated/resources/graphql'

export const useFundaeConfigMapped = ({
  categoryMapConfigs,
  educationLevels,
  professionalCategories,
}: {
  categoryMapConfigs: CategoryMapConfigFragment[]
  educationLevels: EducationLevelFragment[]
  professionalCategories: ProfessionalCategoryFragment[]
}) => {
  const categoryMapped = (
    collection: EducationLevelFragment[] | ProfessionalCategoryFragment[],
    category: TrainingsCategoryMapConfigCategoryEnum
  ) => {
    const categoryMapConfig = categoryMapConfigs.find((cmp) => cmp.category === category)

    if (!categoryMapConfig) {
      return collection.length <= 0
    }

    const collectionIds = collection.map((p) => p.id)
    const mapped = categoryMapConfig.categoryMapConfigItems.filter((cmpi) =>
      collectionIds.includes(cmpi.field.fieldId)
    )

    return mapped.length === collectionIds.length
  }

  return {
    educationLevelMapped: categoryMapped(educationLevels, 'educationlevel'),
    professionalCategoryMapped: categoryMapped(professionalCategories, 'professionalcategory'),
  }
}
